// extracted by mini-css-extract-plugin
export var formContainer = "_mt-0";
export var message = "_mt-1";